<template>
  <div>
    <div class="zhishiku-item mode-tree" v-for="(item,index) in zskList" :key="item.id">
      <p class="zsk-item-tit" :class="item.id === zskid?'active':''">
        <i class="iconfont "
           :class="item.open?'iconcaretdown':'iconcaretright'"
           @click="GetFolderList(item.id,index)"
           style="padding-right: 10px;color: #999;"></i>
        <i class="iconfont " :class="item.icon" style="font-size: 18px"></i>
        <span @click="isopen(item.open,index)">{{item.name}}</span>
      </p>
      <el-tree
        v-if="item.list.length>0"
        :ref="'vueTree'+index"
        :data="item.list"
        :props="defaultProps"
        node-key='id'
        :highlight-current="item.highlightCurrent"
        :expand-on-click-node="false"
        :default-expand-all="true"
        @node-click="handleNodeClick"
        v-show="item.open"></el-tree>
    </div>
  </div>
</template>

<script>
  export default {
    name: "modeTree",
    data() {
      return {
        dialogVisible: false,      //  创建知识库
        addName: '',                 //  创建知识库名称
        zskList: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        zskid: '',
        cid: '',
        chioseKuId:'',   //  选择的库id
        chioseWjId:''   //  选择的文件夹id
      }
    },
    computed: {
      isUpTree() {
        return this.$store.state.upTree
      }
    },
    created() {
      this.getMyAddKu()
    },
    methods: {
      //  获取我添加的知识库
      getMyAddKu() {
        this.$api.apiContent.GetAllList({
          mid: this.$store.state.userMid
        }).then(res => {
          if (res.data) {
            this.zskList = this.zskList.slice(0, 1)
            res.data.map(item => {
              this.zskList.push({
                id: item.id,
                name: item.name,
                icon: item.system === 1 ? 'iconicon' : item.system === 2 ? 'icongongsi_' : 'iconbanbenxinjian',
                open: false,
                highlightCurrent: false,
                list: []
              })
            })
          }
          if (this.$route.query.id === undefined) {
            this.setPath(this.zskList[1].id, this.zskList[1].name)
          }
          this.zskList.map((item, index) => {
            if (item.id === this.zskid) {
              item.open = true
              this.GetFolderList(item.id, index, item.open)
            }
          })
        }).catch(e => {
          console.log(e)
        })
      },
      //  点击树状图
      handleNodeClick(data) {
        console.log(data)
        this.zskid = ''
        this.zskList.map(item => {
          item.highlightCurrent = false
          if (item.id === data.kid) {
            item.highlightCurrent = true
          }
        })
        this.chioseKuId = data.kid
        this.chioseWjId = data.id
        this.$emit('modeSet',this.chioseKuId,this.chioseWjId)
      },
      //  点击知识库
      isopen(state, index) {
        this.zskList.map(item => {
          item.highlightCurrent = false
        })
        this.zskid = this.zskList[index].id
        this.chioseKuId = this.zskList[index].id
        this.chioseWjId = ''
        this.$emit('modeSet',this.chioseKuId,this.chioseWjId)
        // this.setPath(id, this.zskList[index].name)
      },
      setPath(id, name) {
        if (id === 0) {   //  如果是0 为分享给我
          this.$router.push({
            path: '/home/repositoriesShare',
            query: {
              id: id,      //  知识库id
              name: name  //    知识库名称
            }
          })
        } else {
          this.$router.push({
            path: '/home/repositories',
            query: {
              id: id,      //  知识库id
              name: name  //    知识库名称
            }
          })
        }
      },
      setPath2(kid, id, name) {

        this.$router.push({
          path: '/home/list',
          query: {
            id: kid,     //  知识库id
            cid: id,
            name: name  //    文件名称
          }
        })
      },
      setPath3(kid, id, name) {
        this.$router.push({
          path: '/home/detail',
          query: {
            id: kid,     //  知识库id
            cid: id,
            name: name  //    文件名称
          }
        })
      },
      //  获取单个知识库下面的树状图
      GetFolderList(id, index, state) {
        this.$api.apiContent.GetOnlyFolderList({
          mid: this.$store.state.userMid,
          team: id,
          kid: id
        }).then(res => {
          if (res.data) {
            res.data.map(item => {
              if (!item.children) {
                item.children = []
              }
              item.kid = id
            })
            this.zskList[index].list = res.data
            if (state) {
              this.zskList[index].open = true
              this.zskList[index].highlightCurrent = true
              if (this.$route.query.cid) {
                this.$nextTick(() => {
                  console.log(this.$refs['vueTree' + index])
                  let _tree = this.$refs['vueTree' + index]
                  _tree[0].setCurrentKey(this.$route.query.cid);
                })
              }
            } else {
              this.zskList[index].open = !this.zskList[index].open
            }
          }
        }).catch()
      },
      getList() {
        this.zskid = Number(this.$route.query.id)
      }
    },
    watch: {
      '$route': 'getList',
      isUpTree() {
        if (this.isUpTree) {
          this.$store.state.upTree = false
          this.getMyAddKu()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .add-item {
    width: 200px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    margin: 30px auto;
    background: #0a2240;
    color: #fff;
    cursor: pointer;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;

    i {
      position: relative;
      top: 1px;
      padding-right: 3px;
      font-size: 20px;
      color: #fff;
    }
  }

  .zhishiku-item {
    line-height: 40px;
    cursor: pointer;
    font-size: 16px;

  }

  .zsk-item-tit {
    display: flex;

    span {
      flex: 1;
    }
  }

  .zsk-item-tit.active {
    background: #e1effa !important;
    color: #0a2240 !important;
  }
</style>
